export default __webpack_public_path__ + "static/miller-570063adc1c51b8a30b520e8fdca14ce.jpg";